document.addEventListener('DOMContentLoaded', function () {
  const buildSwiperSlider = sliderElm => {
    const sliderIdentifier = sliderElm.dataset.id;
    return new Swiper(`.tab-sliders[data-id="${sliderIdentifier}"]`, {
       observer: true,
       preloadImages: false,
       lazy: true,
       spaceBetween: 10,
        observeParents: true,
        slidesPerView: 2,
        spaceBetween: 5,
        breakpoints: {
         640: {
            slidesPerView: 2,
            spaceBetween: 5,
         },
         768: {
            slidesPerView: 3,
            spaceBetween: 5,
         },
         1024: {
            slidesPerView: 4,
            spaceBetween: 10,
         },
         1300: {
            slidesPerView: 5,
            spaceBetween: 10,
         },
         1524: {
            slidesPerView: 5,
            spaceBetween: 10,
        }
       },
       navigation: {
          nextEl: `.swiper-button-next-${sliderIdentifier}`,
          prevEl: `.swiper-button-prev-${sliderIdentifier}`
       },
    });
   }

  // Get all of the swipers on the page
  const allSliders = document.querySelectorAll('.tab-sliders');

  // Loop over all of the fetched sliders and apply Swiper on each one.
  allSliders.forEach(slider => buildSwiperSlider(slider));
});